import React, { useState, useEffect } from "react";
import { createRoot } from "react-dom/client";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./css/main-menu.css";

// Pages
import Addons from "./pages/Addons";
import Help from "./pages/Help";

const App = () =>{
    const defaultTab = "/addons";
    const [activeTab, setActiveTab] = useState(
        window.location.hash.replace("#", "") || defaultTab
    );

    useEffect(() => {
        const validTabs = ["/addons", "/help"];
        const handleHashChange = () => {
            const newHash = window.location.hash.replace("#", "");
            if (validTabs.includes(newHash)) {
                setActiveTab(newHash);
            } else {
                setActiveTab(defaultTab);
                window.location.hash = "";
            }
        };

        window.addEventListener("hashchange", handleHashChange);

        // Initial check to ensure correct tab is set on page load
        handleHashChange();

        return () => {
            window.removeEventListener("hashchange", handleHashChange);
        };
    }, []);

    return (
        <div className="min-h-screen bg-gray-100">
            {activeTab === "/addons" && <Addons />}
            {activeTab === "/help" && <Help />}

            <ToastContainer />
        </div>
    );
};

// Assuming the container exists in your HTML file
const container = document.getElementById("easycommerce_render");
const root = createRoot(container);
root.render(<App />);

export default App;
